import Vue from "vue";
import { resolveRequestError } from "@/utils/auth";
import * as ENDPOINTS from "./endpoints";

export default class BankAccountService {
  /**
   *  Resolve bank account
   *
   * @async
   * @return {Object} returns message
   */
  static async resolve(accountnumber, bankcode) {
    try {
      const { data } = await Vue.http.get(
        ENDPOINTS.RESOLVE_BANK_ACCOUNT(accountnumber, bankcode)
      );
      return data;
    } catch (err) {
      resolveRequestError(err, undefined, false);
    }
  }

  /**
   *  Resolve bank account and add
   *
   * @async
   * @return {Object} returns message
   */
  static async add({ accountnumber, bankcode, otp }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.ADD_BANK_ACCOUNT, {
        accountnumber,
        bankcode,
        otp,
        purpose: "addbank"
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   * Remove bank account
   *
   * @return {Object} message
   */
  static async delete(bankaccountid, otp) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.DELETE_BANK_ACCOUNT, {
        bankaccountid,
        otp
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   * Get all bank accouts
   *
   * @return {Object}
   */
  static async getAll() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.BANK_ACCOUNTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   * Withdraw
   * @param {Object} data
   * @param {Number} data.bankaccountid
   * @param {Number} data.amount
   * @param {String} data.otp
   *
   * @return {Object}
   */
  static async withdraw({ bankaccountid, amount, otp }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.WITHDRAW, {
        bankaccountid: Number(bankaccountid),
        amount: Number(amount),
        otp
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }
}
